/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateImportPreviewMutationRequest,
  CreateImportPreviewMutationResponse,
  CreateImportPreview400,
} from '../types/CreateImportPreview'

function getCreateImportPreviewUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/importengine/previews/v2/` as const,
  }
  return res
}

/**
 * @summary Create an import preview and dispatch the prepare task
 * {@link /api/v1/importengine/previews/v2/}
 */
export async function createImportPreview(
  data: CreateImportPreviewMutationRequest,
  config: Partial<RequestConfig<CreateImportPreviewMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateImportPreviewMutationResponse,
    ResponseErrorConfig<CreateImportPreview400>,
    CreateImportPreviewMutationRequest
  >({
    method: 'POST',
    url: getCreateImportPreviewUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
